import axios from "axios";
export const API_URL = "https://srinivasafleet.com/api";


const api = axios.create({ baseURL: API_URL });
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login?reason=session_revoked";
      }
    }
    return Promise.reject(error);
  }
);

export const getVehicleAssignments = async (opts = {}) => {
  const params = {};
  if (opts.allYears) {
    params.all_years = true;
  } else if (opts.financialYearId) {
    params.financial_year_id = opts.financialYearId;
  }
  if (opts.assignmentTypeId) {
    params.assignment_type_id = opts.assignmentTypeId;
  }
  if (opts.supplierType) {
    params.supplier_type = opts.supplierType;
  }
  if (opts.vehicleModel) {
    params.vehicle_model = opts.vehicleModel;
  }
  if (opts.locationId) {
    params.location_id = opts.locationId;
  }
  if (opts.branchId) {
    params.branch_id = opts.branchId;
  }
  if (opts.outstandingMin !== undefined && opts.outstandingMin !== null) {
    params.outstanding_min = opts.outstandingMin;
  }
  if (opts.outstandingMax !== undefined && opts.outstandingMax !== null) {
    params.outstanding_max = opts.outstandingMax;
  }
  const res = await api.get("/vehicle-assignments/", { params });
  return res.data;
};

export const getVehicleAssignmentById = async (id) => {
  const res = await api.get(`/vehicle-assignments/${id}`);
  return res.data;
};

export const getVehicleAssignmentDocuments = async (id) => {
  const res = await api.get(`/vehicle-assignments/${id}/documents`);
  return res.data;
};

export const getAssignmentChain = async (chainId) => {
  const res = await api.get(`/vehicle-assignments/chain/${chainId}`);
  return res.data;
};

export const getAssignmentTypeOptions = async () => {
  const res = await api.get("/vehicle-assignments/filters/types");
  return res.data;
};

export const getSupplierTypeOptions = async () => {
  const res = await api.get("/vehicle-assignments/filters/supplier-types");
  return res.data;
};

export const getVehicleModelOptions = async () => {
  const res = await api.get("/vehicle-assignments/filters/models");
  return res.data;
};

export const getLocationOptions = async () => {
  const res = await api.get("/vehicle-assignments/filters/locations");
  return res.data;
};

export const getBranchesByLocation = async (locationId) => {
  const res = await api.get("/vehicle-assignments/filters/branches", {
    params: { location_id: locationId },
  });
  return res.data;
};

export const getAvailableVehicles = async () => {
  const res = await api.get("/vehicle-assignments/available/vehicles");
  return res.data;
};

export const getAvailableDrivers = async () => {
  const res = await api.get("/vehicle-assignments/available/drivers");
  return res.data;
};

export const getAvailableSuppliers = async () => {
  const res = await api.get("/vehicle-assignments/available/suppliers");
  return res.data;
};

export const createVehicleAssignment = async (data) => {
  const res = await api.post("/vehicle-assignments/", data);
  return res.data;
};

export const updateVehicleAssignment = async (id, data) => {
  const res = await api.put(`/vehicle-assignments/${id}`, data);
  return res.data;
};

export const deleteVehicleAssignment = async (id) => {
  const res = await api.delete(`/vehicle-assignments/${id}`);
  return res.data;
};

export const uploadVehicleAssignmentDocument = async (field, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await api.post(
    `/vehicle-assignments/upload-document?field=${field}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return res.data;
};